/*
 * Copyright (c) 2014-2023 Comparatio
 */

import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {ICompany} from '../model/interfaces/company.interface';
import {GeneralService} from './general.service';
import {Injectable} from '@angular/core';
import {EDIServices} from './edi.services';

@Injectable()
export class CompanyService extends GeneralService implements EDIServices<Observable<ICompany>, ICompany, number> {

    constructor(protected http: HttpClient) {
        super(http);
    }

    getById(id: number): Observable<ICompany> {

        if (id === 0) {
            return Observable.of(this.initialize());
        }

        const url = `${this.apiUrl}/companies/${id}`;
        return this.http.get(url)
            .map(
                data => this.extractPayload(data)
            )
            .catch(this.handleError);
    }

    save(company: ICompany, isCreate: boolean): Observable<ICompany> {
        if (company.CO1_ID === 0 || isCreate) {
            return this.create(company);
        }

        return this.update(company);
    }

    public getCompanies(page): Observable<any> {
        return this.getList(page, '/companies');
    }

    public getDuplicateCompanies(page): Observable<any> {
        return this.getList(page, '/companies/vendor-duplicates');
    }

    public getDuplicateCustomerCompanies(page): Observable<any> {
        return this.getList(page, '/companies/customer-duplicates');
    }

    private create(company: ICompany): Observable<ICompany> {
        return this.http.post(this.apiUrl + '/companies/', company)
            .do(data => console.log('createCompany: ' + JSON.stringify(data)))
            .catch(this.handleError);
    }

    private update(company: ICompany): Observable<ICompany> {
        const url = `${this.apiUrl + '/companies'}/${company.CO1_ID}`;
        return this.http.put(url, company)
            .catch(this.handleError);
    }

    public delete(id: number) {
        return this.http.delete<any>(this.apiUrl + '/companies/' + id);
    }

    public getAccess(id: number) {
        const url = `${this.apiUrl + '/companies/access/' + id}`;
        return this.http.get(url)
            .catch(this.handleError);
    }

    public setAccess(id: number, data: any) {
        const url = `${this.apiUrl + '/companies/access/' + id}`;
        return this.http.put(url, data)
            .catch(this.handleError);
    }

    public initialize() {
        return {
            'CO1_ID': 0,
            'CO1_NAME': null,
            'CO1_SHOW_DEFAULT': null,
            'CO1_IP': null,
            'CO1_CREATED_ON': null,
            'CO1_MODIFIED_ON': null,
            'CO1_LOGO_FILEPATH': null,
            'CO1_DOMAIN': null,
            'CO1_COMPANY_LOGO_NAME': null,
            'CO1_EMAIL_SENDER_NAME': null,
            'CO1_EMAIL_COMPANY_NAME': null,
            'CO1_PO_PDF_FOOTER': null,
            'CO1_API_URL': null,
            'CO1_API_USERNAME': null,
            'CO1_API_ACCESS_KEY': null
        };
    }
    
    public getShortCompanyList() : Observable<any> {
        return this.http.get(this.apiUrl + '/company/short-company-list');
    }
}



// WEBPACK FOOTER //
// /home/ubuntu/edi/angular/app/services/company.service.ts